"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var selectable_credit_card_list_container_1 = require("../credit_cards/selectable_credit_card_list_container");
var Document = require("../schemas/local.gql");
// resolver functions return default values for locally extended types
// (ex: creditCard.isSelected is a client-side cached value, its default value
// is determined by its resolver function)
exports.resolvers = tslib_1.__assign(tslib_1.__assign({}, selectable_credit_card_list_container_1.resolvers), { Mutation: {
        selectCard: selectable_credit_card_list_container_1.selectCard,
    } });
// type definitions for mutations, mutation queries,
// and extended types used for local caching
exports.typeDefs = tslib_1.__assign({}, Document);
//# sourceMappingURL=local_apollo_schema.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/lib/local_apollo_schema.js
// module id = 9hBZ
// module chunks = 20 21